import { render } from "./PictureNew2.vue?vue&type=template&id=214cbc44&scoped=true"
import script from "./PictureNew2.vue?vue&type=script&lang=js"
export * from "./PictureNew2.vue?vue&type=script&lang=js"

import "./PictureNew2.vue?vue&type=style&index=0&id=214cbc44&scoped=true&lang=css"
import "./PictureNew2.vue?vue&type=style&index=1&id=214cbc44&lang=css"

import exportComponent from "D:\\others\\ysj\\leer\\wisdom\\html\\app\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-214cbc44"]])

export default __exports__